import React from 'react';
import { createRoot } from 'react-dom/client';

import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

import '@/assets/styles/colors.css';
import '@/assets/styles/globals.css';
import '@/assets/styles/typography.css';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { RouterProvider, createRouter } from '@tanstack/react-router';

import {
    DATADOG_APPLICATION_ID,
    DATADOG_CLIENT_TOKEN,
    ENV,
    VERSION,
} from './lib/config';
import { isRumConfigured } from './lib/datadog';
import { persistOptions, queryClient } from './lib/tanstackQuery';
import { routeTree } from './routeTree.gen';

if (isRumConfigured()) {
    datadogRum.init({
        applicationId: DATADOG_APPLICATION_ID,
        clientToken: DATADOG_CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: 'sonance_ui',
        env: ENV,
        version: VERSION,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        plugins: [reactPlugin({ router: false })],
    });
}

// TODO: Make these on their own service files
const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router;
    }
    interface HistoryState {
        isSessionExpired?: boolean;
    }
}

const root = createRoot(document.getElementById('root')!);

// Add providers, initialisers, any setup code here
root.render(
    <React.StrictMode>
        <PersistQueryClientProvider
            client={queryClient}
            persistOptions={persistOptions}
        >
            <RouterProvider router={router} />
        </PersistQueryClientProvider>
    </React.StrictMode>,
);
